import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Data } from 'app/models2/commos/base-response-data';
import { InspectionForm } from 'app/models2/inspections/inspection-form';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import {
  HeaderFilters,
  HttpService,
  MenuBreadCrumb,
  MessageService,
  params,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { FormControl } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { BaseResponse } from 'app/models2/commos/base-response';
import { GenericResponse } from 'app/models2/commos/generic-response';

export enum stateTab {
  TABLE = 0,
  DETAIL = 1,
}

@Component({
  selector: 'app-inspection-form',
  templateUrl: './inspection-form.component.html',
  styleUrls: ['./inspection-form.component.scss'],
})
export class InspectionFormComponent implements OnInit {
  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Inspecciones / Formulario',
      current: true,
    },
  ];

  private urlCrudIF: string = `${EndpointDictionary.InspectionForm.CRUD_INSPECTION_FORM_DATA}`;
  private inactivateInspectionForm: string = `${EndpointDictionary.InspectionForm.INACTIVATE_INSPECTION_FORM}`;
  private activeInspectionForm: string = `${EndpointDictionary.InspectionForm.ACTIVE_INSPECTION_FORM}`;

  public EndpointDictionary = EndpointDictionary;
  public stateTab = stateTab;

  public paramsInspectionForm: params[] = [
    {
      id: 'active',
      value: 1,
    },
  ];

  public titleIF: string = screen.width > 360 ? 'Formularios Inspecciones' : 'F.I'

  public isChecked: boolean = true;
  public labelToggle: string = 'Formularios Inspección activos';
  public selected = new FormControl(0);
  public label: string;
  public currentState: stateTab = stateTab.TABLE;
  public inspectionForm: InspectionForm = null;
  public hasFormChanges: boolean = false;

  public reloadTableIF = new EventEmitter<any>();
  public configurationIF: TableConfiguration = {
    edit: true,
    add: true,
    addPer: true,
    editPer: true,
    selectable: true,
    primaryKey: 'id',
    exportXslx: true,
    active: true,
    delete: false,
  };

  public configurationInactiveIF: TableConfiguration = {
    primaryKey: 'id',
    active: true,
    selectable: true,
  };

  public columnsIF: TableColumns<InspectionForm>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'version',
      label: 'Versión',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'dateFormat',
      label: 'Formato Fecha',
      type: 'fecha',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'periodicityValue',
      label: 'Periodicidad',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  headerFilters: Array<HeaderFilters> = [
    {
      tN: 'tipo_periodicidad',
      labelFilter: 'Tipo Periodicidad',
      urlData: EndpointDictionary.PeriodicityType.PERIODICITY_TYPE_COMBO,
      visibleField: 'name',
      primaryKey: 'id',
      type: 'select',
      value: '',
    },
    {
      tN: 'formulario_inspeccion',
      labelFilter: 'código formato',
      visibleField: 'inspectionCode',
      fileNameDb: 'codigo',
      urlData: this.EndpointDictionary.InspectionForm.COMBO_CODE,
      type: 'select',
      value: '',
    },
    {
      tN: 'formulario_inspeccion',
      labelFilter: 'versión formato',
      visibleField: 'versionInspection',
      fileNameDb: 'version',
      urlData: this.EndpointDictionary.InspectionForm.COMBO_VERSION,
      type: 'select',
      value: '',
    },
    {
      tN: 'formulario_inspeccion',
      visibleField: 'formato_fecha',
      type: 'date',
      value: '',
    },
    {
      tN: 'formulario_inspeccion',
      visibleField: 'formato_fecha',
      type: 'dateRange',
      value: '',
    },
  ];

  headerFileXlsm: Array<params> = [
    { id: 'name', value: 'Nombre' },
    { id: 'version', value: 'Versión' },
    { id: 'code', value: 'Código' },
    { id: 'dateFormat', value: 'Formato Fecha' },
    { id: 'periodicityValue', value: 'Periodicidad' },
    { id: 'description', value: 'Descripción' },
  ];

  constructor(
    private http: HttpService,
    private deleteService: DeleteGenericService,
    private message: MessageService
  ) {}

  ngOnInit(): void {}

  dataFromTable($event: Data<InspectionForm[]>) {
    if (this.isChecked) {
      this.configurationIF.active = false;
    } else {
      this.configurationIF.active = true;
    }
  }

  async addIF($event: InspectionForm) {
    this.inspectionForm = null;
    this.label = 'Crear Formulario';
    this.selected.setValue(1);
    this.currentState = stateTab.DETAIL;
  }

  async editIF($event: InspectionForm[]) {
    this.message.openLoading('Cargando', `Editando Formulario`);
    let inspectionFormId = $event[0].id;
    let res: Array<InspectionForm> = await this.http.getDataBody(
      `${EndpointDictionary.InspectionForm.CRUD_INSPECTION_FORM_DATA}/${inspectionFormId}`
    );
    if (res) {
      this.inspectionForm = res[0];
      this.label = 'Actualizar Formulario';
      this.selected.setValue(1);
      this.currentState = stateTab.DETAIL;
    }
    this.message.closeLoading();
  }

  async inactivateOrActiveInspectionForms(
    $event: InspectionForm[],
    active: boolean
  ) {
    if (!Array.isArray($event)) {
      $event = [$event];
    }
    this.message.openLoading('Cargando', `Inactivando Formulario`);
    await this.deleteService.inactivateOrActivate(
      $event,
      active,
      this.activeInspectionForm,
      this.inactivateInspectionForm,
      'Formulario'
    );
    this.reloadTableIF.emit();
    this.message.closeLoading();
  }

  changeToggle($event: MatSlideToggleChange) {
    if ($event.checked) {
      this.labelToggle = 'Formularios Inspección Activos';
      this.paramsInspectionForm[0].value = 1;
    } else {
      this.labelToggle = 'Formularios Inspección Inactivos';
      this.paramsInspectionForm[0].value = 0;
    }
    this.reloadTableIF.emit();
  }

  async deleteIF($event: InspectionForm[]) {
    try {
      // Confirmación inicial
      const deleteConfirm = await this.message.Warning(
        `¿Desea eliminar ${
          $event.length > 1 ? 'los formularios seleccionados' : 'el formulario'
        }?`,
        '',
        true
      );
      if (!deleteConfirm) {
        this.message.SuccessToast('Operación cancelada');
        return;
      }

      this.message.openLoading(
        'Cargando',
        `Eliminando ${$event.length > 1 ? 'formularios' : 'formulario'}`
      );

      const deleteItem = async (item: InspectionForm) => {
        let res: BaseResponse<GenericResponse> =
          await this.http.deleteDataPromise(`${this.urlCrudIF}/${item.id}`);
        if (res['code'] === 1) {
          const confirm = await this.message.Warning(res.message, '', true);
          if (confirm) {
            let resDelete: BaseResponse<GenericResponse> =
              await this.http.deleteDataPromise(
                `${this.urlCrudIF}/${item.id}?deleteHistorical=true`
              );
            if (resDelete['code'] === 0) {
              this.message.SuccessToast(resDelete.message);
            } else {
              this.message.Warning('Error!', resDelete.message);
            }
          } else {
            this.message.SuccessToast(`Operación cancelada`);
          }
        } else if (res['code'] === 0) {
          this.message.SuccessToast(`Formulario eliminado correctamente'.`);
        } else {
          this.message.Warning('Error!', res.message);
        }
      };

      for (const item of $event) {
        await deleteItem(item);
      }
    } catch (error) {
      this.message.Warning(
        'Error inesperado',
        error.message || 'Ocurrió un error al eliminar el formulario.'
      );
    } finally {
      this.message.closeLoading();
      this.reloadTableIF.emit();
    }
  }

  completeCreateForm() {
    this.reloadTableIF.emit();
    this.selected.setValue(0);
    this.currentState = stateTab.TABLE;
  }

  onFormChanged(hasChanges: boolean) {
    this.hasFormChanges = hasChanges;
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selected.setValue(event.index);
    if (event.index === 0 && this.hasFormChanges) {
      this.reloadTableIF.emit();
      this.hasFormChanges = false;
    }
  }
}
